import { WidgetType } from '@lastbrand/storefront-proto-registry/api/v1/enums'

import { PLBaseErrorBoundary } from '@src/components/pl-base-error-boundary'
import { PLTypedWidgetInterface } from '@src/components/pl-base-widget'

import { TransparentPricingWidgetComponent } from './transparent-pricing-widget.component'

import type { TransparentPricingWidgetData } from '@lastbrand/storefront-proto-registry/api/v1/widget'

export const TransparentPricingWidget: PLTypedWidgetInterface<
  TransparentPricingWidgetData,
  WidgetType.TRANSPARENT_PRICING
> = {
  id: WidgetType.TRANSPARENT_PRICING,
  errorBoundary: PLBaseErrorBoundary,
  render: TransparentPricingWidgetComponent,
}
